import * as React from 'react';
import * as styles from './styles.css';

export interface IChartProps {
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  chartCanvasRef: React.RefObject<HTMLCanvasElement>;
  chartHeight: number;
  onScroll?(): void;
}

export const Chart: React.FC<IChartProps> = ({ scrollContainerRef, chartCanvasRef, chartHeight, onScroll }) => {
  return (
    <div ref={scrollContainerRef} onScroll={onScroll} className={styles['wrapper']}>
      <div className={styles['chart']} style={{ height: chartHeight }}>
        <canvas ref={chartCanvasRef} />
      </div>
    </div>
  );
};

Chart.displayName = 'Chart';
